const attachObserverToInput = (element, inputObserver) => {
    // For non-dom environments
    if (typeof MutationObserver === 'undefined')
        return;
    inputObserver = new MutationObserver((mutationsList) => {
        for (const mutation of mutationsList) {
            if (mutation.type === 'attributes') {
                const attributeValue = element.getAttribute(mutation.attributeName);
                if (attributeValue === 'false') {
                    element.removeAttribute(mutation.attributeName);
                }
            }
        }
    });
    // Start observing the target node for configured mutations
    inputObserver.observe(element, { attributes: true });
};

export { attachObserverToInput as a };

//# sourceMappingURL=inputObserver-6de9a524.js.map